module.exports = "/_next/static/images/5e2895baf9f985a4684569890af7bf75-piecito-mobile.png.webp";